import { Component, OnDestroy, OnInit, Input} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
//import { GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";

import { Observable, of, Subscription } from "rxjs";
import { filter, tap } from 'rxjs/operators';

import { RouterLinkRendererComponent } from '../../../../common/components/ag-grid/router-link-renderer.component';
import { ModalInfoComponent } from "../../../../common/components/ag-grid/modal-info.component";
import { FlowIndex } from "../../../../common/models/flow.dto"
import { FlowInstanceService } from '../../../../flow/services/flow-instance.service';
import { AuthService } from '../../../../services/auth.service';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { TabComponent } from '../../../../common/components/tabs/tab.component';

@Component({
    selector: 'well-transfer-seller-widget',
    templateUrl: './well-transfer-seller-widget.component.html',
    styleUrls: ['./well-transfer-seller-widget.component.scss'],
    standalone: false
})
export class WellTransferSellerWidgetComponent implements OnInit, OnDestroy {
    @Input() widgetTitle: string;

    subscriptions: Subscription = new Subscription();
    actionNeededData: FlowIndex[];
    notSubmittedData: FlowIndex[];
	actionNeededGridOptions: GridOptions;
	actionNeededGridApi?: GridApi;
	notSubmittedGridOptions: GridOptions;
	notSubmittedGridApi?: GridApi;
    pendingData: FlowIndex[];
	pendingGridOptions: GridOptions;
	pendingGridApi?: GridApi;
    incompleteData: FlowIndex[];
	incompleteGridOptions: GridOptions;
	incompleteGridApi?: GridApi;
    deniedData: FlowIndex[];
	deniedGridOptions: GridOptions;
	deniedGridApi?: GridApi;
    approvedData: FlowIndex[];
	approvedGridOptions: GridOptions;
	approvedGridApi?: GridApi;
    sellerOrgId: string;

    constructor(
        public readonly flowService: FlowInstanceService,
        private formatterService: GridFormatterService,
        public readonly authService: AuthService,
        private router: Router
    ) {

    }

    ngOnInit() {
		this.notSubmittedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.notSubmittedColDefs());
		this.notSubmittedGridOptions.onGridReady = (params) => { this.notSubmittedGridApi = params.api; };
		this.notSubmittedGridOptions.headerHeight = 50;
        this.actionNeededGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.submittedColDefs());
		this.actionNeededGridOptions.onGridReady = (params) => { this.actionNeededGridApi = params.api; };
        this.actionNeededGridOptions.headerHeight = 50;
		this.pendingGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.pendingColDefs());
		this.pendingGridOptions.onGridReady = (params) => { this.pendingGridApi = params.api; };
        this.pendingGridOptions.headerHeight = 50;
		this.incompleteGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.incompleteColDefs());
		this.incompleteGridOptions.onGridReady = (params) => { this.incompleteGridApi = params.api; };
        this.incompleteGridOptions.headerHeight = 50;
		this.deniedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.deniedColDefs());
		this.deniedGridOptions.onGridReady = (params) => { this.deniedGridApi = params.api; };
        this.deniedGridOptions.headerHeight = 50;
		this.approvedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.approvedColDefs());
		this.approvedGridOptions.onGridReady = (params) => { this.approvedGridApi = params.api; };
        this.approvedGridOptions.headerHeight = 50;

        let obs$ = this.refreshData("not submitted").subscribe(
            () => { console.log(`tab not submitted data refreshed`) },
            (error) => { console.error(error); }
        );
        this.subscriptions.add(obs$);

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onTabClicked(tab: TabComponent): void {
        const title = tab.title.toLocaleLowerCase();
        let obs$: Observable<FlowIndex[]> = this.refreshData(title);
        let subs$ = obs$.subscribe(
            () => { console.log(`tab ${title} data refreshed`) },
            (error) => { console.error(error); }
        );
        this.subscriptions.add(subs$);
    }


    refreshData(tabName: string): Observable<FlowIndex[]> {
        let obs$: Observable<FlowIndex[]> = of([]);
        let queryParams = new Map<string, string>();
        queryParams.set("@transfererCompanyId", this.authService.User.organizationId);

        switch (tabName.toLocaleLowerCase()) {
            case "not submitted":
                if (this.notSubmittedGridOptions && this.notSubmittedGridApi) {
                    this.notSubmittedGridApi.setGridOption("rowData", []);
                    this.notSubmittedGridApi.setGridOption("loading", true);
                }
                obs$ = this.flowService.queryFlowIndices("WTSellerNotSubmitted", null, queryParams).pipe(tap((results: FlowIndex[]) => {
                    this.notSubmittedData = results;
                    if (this.notSubmittedGridApi != null) {
                        this.notSubmittedGridApi.sizeColumnsToFit();
                        this.notSubmittedGridApi.setGridOption("loading", false);
                    }                    
                }));
                break;
            case "action needed":
                if (this.actionNeededGridOptions && this.actionNeededGridApi) {
                    this.actionNeededGridApi.setGridOption("rowData", []);
                    this.actionNeededGridApi.setGridOption("loading", true);
                }
                obs$ = this.flowService.queryFlowIndices("WTSellerActionNeeded", null, queryParams).pipe(tap((results: FlowIndex[]) => {
                    this.actionNeededData = results;
                    if (this.actionNeededGridApi != null) {
                        this.actionNeededGridApi.sizeColumnsToFit();
                        this.actionNeededGridApi.setGridOption("loading", false);
                    }                    
                }));
                break;
            case "pending":
                if (this.pendingGridOptions && this.pendingGridApi) {
                    this.pendingGridApi.setGridOption("rowData", []);
                    this.pendingGridApi.setGridOption("loading", true);
                }
                obs$ = this.flowService.queryFlowIndices("WTSellerPending", undefined, queryParams).pipe(tap((results: FlowIndex[]) => {
                    this.pendingData = results;
                    if (this.pendingGridApi != null) {
                        this.pendingGridApi.sizeColumnsToFit();
                        this.pendingGridApi.setGridOption("loading", false);
                    }
                }));
                break;
            case "incomplete":
                if (this.incompleteGridOptions && this.incompleteGridApi) {
                    this.incompleteGridApi.setGridOption("rowData", []);
                    this.incompleteGridApi.setGridOption("loading", true);
                }
                obs$ = this.flowService.queryFlowIndices("WTSellerIncomplete", undefined, queryParams).pipe(tap((results: FlowIndex[]) => {
                    this.incompleteData = results;
                    if (this.incompleteGridApi != null) {
                        this.incompleteGridApi.sizeColumnsToFit();
                    this.incompleteGridApi.setGridOption("loading", false);
                    }
                }));
                break;
            case "denied":
                if (this.deniedGridOptions && this.deniedGridApi) {
                    this.deniedGridApi.setGridOption("rowData", []);
                    this.deniedGridApi.setGridOption("loading", true);
                }
                obs$ = this.flowService.queryFlowIndices("WTSellerDenied", undefined, queryParams).pipe(tap((results: FlowIndex[]) => {
                    this.deniedData = results;
                    if (this.deniedGridApi != null) {
                        this.deniedGridApi.sizeColumnsToFit();
                        this.deniedGridApi.setGridOption("loading", false);
                    }
                })); 
                break;
            case "approved":
                if (this.approvedGridOptions && this.approvedGridApi) {
                    this.approvedGridApi.setGridOption("rowData", []);
                    this.approvedGridApi.setGridOption("loading", true);
                }
                obs$ = this.flowService.queryFlowIndices("WTSellerApproved", null, queryParams).pipe(tap((results: FlowIndex[]) => {
                    this.approvedData = results;
                    if (this.approvedGridApi != null) {
                        this.approvedGridApi.sizeColumnsToFit();
                        this.approvedGridApi.setGridOption("loading", false);
                    }
                })); 
                break;
        }

        return obs$;
    }

    dateCreatedColumn = {
        comparator: dateComparator,
        headerClass: "wrapped",
        headerName: "Created",
        headerTooltip: "Created",
        field: "createdDate",
        tooltipValueGetter: this.formatterService.formatDate("createdDate"),
        valueGetter: this.formatterService.formatDate("createdDate"),
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        maxWidth: 150
    } as ColDef;

    transferorColumn = {
        headerClass: "wrapped",
        headerName: "Transferor",
        headerTooltip: "Transferor",
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        field: "transfererCompanyName",
        tooltipField: "transfererCompanyName",
    } as ColDef;

    transfereeColumn = {
        headerClass: "wrapped",
        headerName: "Transferee",
        headerTooltip: "Transferee",
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        field: "transfereeCompanyName",
        tooltipField: "transfereeCompanyName",
    } as ColDef;

    applicationNumberLink = {
        headerClass: "wrapped",
        headerName: "Application Number",
        headerTooltip: "Application Number",
        tooltipField: 'flowIdentifier',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        field: "flowIdentifier",
        cellRendererSelector: (params) => {
            if (params.data.onBehalf) {
                return {
                    component: ModalInfoComponent,
                    params: {
                        modalText: (data) => { return `Application ${data.flowIdentifier} is a paper submission that must be completed by ODNR.`; },
                        text: (data) => { return data.flowIdentifier; }
                    }
                }
            } else {
                return {
                    component: RouterLinkRendererComponent,
                    params: {
                        textField: 'flowIdentifier',
                        flowIdField: 'flowId'
                    }
                }
            }
        },
        maxWidth: 200
    } as ColDef;

    public submittedColDefs() {
        return [
            {
                headerClass: "wrapped",
                comparator: dateComparator,
                headerName: "Date Submitted",
                headerTooltip: "Date Submitted",
                field: "modifiedDate",
                tooltipValueGetter: this.formatterService.formatDate("modifiedDate"),
                valueGetter: this.formatterService.formatDate("modifiedDate"),
                filter: "agDateColumnFilter",
                filterParams: this.formatterService.defaultDateFilterParams,
                maxWidth: 200
            },
            this.applicationNumberLink,
            this.transfereeColumn,
            {
                headerClass: "wrapped",
                headerName: "Status",
                headerTooltip: "Status",
                field: "state",
                tooltipField: "state",
            },

        ] as ColDef[];
    }

    public notSubmittedColDefs() {
        return [
            this.dateCreatedColumn,
            this.applicationNumberLink,
            this.transfereeColumn
        ] as ColDef[];
    }

    public pendingColDefs() {
        return [
            this.dateCreatedColumn,
            this.applicationNumberLink,
            this.transfereeColumn
        ] as ColDef[];
    }

    public incompleteColDefs() {
        return [
            {
                headerClass: "wrapped",
                comparator: dateComparator,
                headerName: "Date Application Incomplete",
                headerTooltip: "Date Application Incomplete",
                field: "ejectedIncomplete",
                tooltipValueGetter: this.formatterService.formatDate("ejectedIncomplete"),
                valueGetter: this.formatterService.formatDate("ejectedIncomplete"),
                filter: "agDateColumnFilter",
                filterParams: this.formatterService.defaultDateFilterParams,
                //maxWidth: 150
            },
            {
                headerClass: "wrapped",
                headerName: "Application Number",
                headerTooltip: "Application Number",
                tooltipField: 'flowIdentifier',
                field: "flowIdentifier",
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
            },
            this.transferorColumn,
            this.transfereeColumn
        ] as ColDef[];
    }

    public deniedColDefs() {
        return [
            {
                headerClass: "wrapped",
                headerName: "Application Number",
                headerTooltip: "Application Number",
                tooltipField: 'flowIdentifier',
                field: "flowIdentifier",
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
            },
            {
                headerClass: "wrapped",
                comparator: dateComparator,
                headerName: "Date Application Denied",
                headerTooltip: "Date Application Denied",
                field: "rejectedDate",
                tooltipValueGetter: this.formatterService.formatDate("rejectedDate"),
                valueGetter: this.formatterService.formatDate("rejectedDate"),
                filter: "agDateColumnFilter",
                filterParams: this.formatterService.defaultDateFilterParams,
                //maxWidth: 150
            },
            this.transferorColumn,
            this.transfereeColumn
        ] as ColDef[];
    }

    public approvedColDefs() {
        return [
            {
                headerClass: "wrapped",
                headerName: "Application Number",
                headerTooltip: "Application Number",
                tooltipField: 'flowIdentifier',
                field: "flowIdentifier",
                filter: "agTextColumnFilter",
                filterParams: this.formatterService.defaultTextFilterParams,
            },
            {
                headerClass: "wrapped",
                comparator: dateComparator,
                headerName: "Date Application Approved",
                headerTooltip: "Date Application Approved",
                field: "approvedDate",
                tooltipValueGetter: this.formatterService.formatDate("approvedDate"),
                valueGetter: this.formatterService.formatDate("approvedDate"),
                filter: "agDateColumnFilter",
                filterParams: this.formatterService.defaultDateFilterParams,
                minWidth: 200
            },
            this.transferorColumn,
            this.transfereeColumn
        ] as ColDef[];
    }
}
